
// export const server = 'http://192.168.248.20:9443'; // testing server
export const server = 'https://api.imunify360.com';

export const baseEndpoint = `${server}/api/`;

// export const TEST_SERVER_ID = 'test-id';
export const TEST_SERVER_ID = undefined;
